/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Medialibraryopendetails3Inputs */

const en_medialibraryopendetails3 = /** @type {(inputs: Medialibraryopendetails3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open details for “${i?.title}”`)
};

const de_medialibraryopendetails3 = /** @type {(inputs: Medialibraryopendetails3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Details zu „${i?.title}“ öffnen`)
};

/**
* | output |
* | --- |
* | "Open details for “{title}”" |
*
* @param {Medialibraryopendetails3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibraryopendetails3 = /** @type {((inputs: Medialibraryopendetails3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibraryopendetails3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibraryopendetails3(inputs)
	return de_medialibraryopendetails3(inputs)
});
export { medialibraryopendetails3 as "mediaLibraryOpenDetails" }